import React from "react"
import { Button, Image } from '@health-zelas/delta'
import Logo from '../../images/logo.svg'
import * as S from './styles'

type HeaderProps = {
  hasProducts: boolean
  isLastStep: boolean
}

const Header = ({ hasProducts, isLastStep }: HeaderProps) => {
  return (
    <S.Header css={{ justifyContent: isLastStep ? 'space-between' : 'center' }}>
      <a href="https://saude.zelas.com.br/">
        <Image src={Logo} alt='Zelas Saude' />
      </a>

      {isLastStep &&
        <Button
          id={hasProducts ? 'pagina_inicial_resultado_simulacao' : 'pagina_inicial_sem_resultado_simulacao'}
          className={hasProducts ? 'resultado_simulacao' : 'sem_resultado_simulacao'}
          size="small"
          variant="secondary"
          as="a"
          href="https://saude.zelas.com.br/">
          Ir para página inicial
        </Button>
      }
    </S.Header>
  )
}

export default Header
